import { useRoleBasedAccess } from '@app/main/utils';
import { RouteObject } from 'react-router-dom';
import { routes } from './routes';
import { useMemo } from 'react';

export function usePatientDetailsModuleRoute() {
  const roleAccessMap = useRoleBasedAccess();

  return useMemo(() => {
    /**
     * No index route might be specified as it would be appended for a first available indexable route
     * Order might be same as on PatientPageModule.tsx
     */
    const CHILDREN = routes([
      roleAccessMap.PatientManagementRoles && {
        path: 'dashboard',
        indexable: true,
        lazy: () =>
          import('./Patients.ProfileDashboard/PatientProfileDashboardPage').then(
            ({ PatientProfileDashboardPage }) => ({
              Component: PatientProfileDashboardPage,
            }),
          ),
      },
      roleAccessMap.PatientManagementRoles && {
        path: 'demographics',
        indexable: true,
        lazy: () =>
          import('./Patients.Demographics/PatientDemographicsPage').then(({ PatientDemographicsPage }) => ({
            Component: PatientDemographicsPage,
          })),
      },
      roleAccessMap.PatientManagementRoles && {
        path: 'encounter',
        indexable: true,
        lazy: () =>
          import('./Patients.Encounters.List/PatientEncounterListPage').then(
            ({ PatientEncounterListPage }) => ({
              Component: PatientEncounterListPage,
            }),
          ),
      },
      roleAccessMap.PatientManagementRoles && {
        path: 'consent',
        indexable: true,
        lazy: () =>
          import('./Consents.List/ConsentsListPage').then(({ ConsentsListPage }) => ({
            Component: ConsentsListPage,
          })),
      },
      roleAccessMap.PatientManagementRoles && {
        path: 'consent/:consentId',
        lazy: () =>
          import('./PatientPortal.Consents.Details/PatientPortalConsentDetailsPage').then(
            ({ PatientPortalConsentDetailsPage }) => ({
              Component: PatientPortalConsentDetailsPage,
            }),
          ),
      },
      roleAccessMap.PatientManagementRoles && {
        path: 'document',
        indexable: true,
        lazy: () =>
          import('./Patients.Documents.List/PatientDocumentsListPage').then(
            ({ PatientDocumentListPage }) => ({
              Component: PatientDocumentListPage,
            }),
          ),
      },
      roleAccessMap.PatientPortalAccessRoles && {
        path: 'settings',
        indexable: true,
        lazy: () =>
          import('./Patients.Settings/PatientSettingsPage').then(({ PatientSettingsPage }) => ({
            Component: PatientSettingsPage,
          })),
      },
    ]);

    const PATIENT_DETAILS_MODULE: RouteObject = {
      path: '/patient/:patientId',
      lazy: () =>
        import('./Patients.Module').then(({ PatientPageModule }) => ({ Component: PatientPageModule })),
      children: CHILDREN,
    };

    return PATIENT_DETAILS_MODULE;
  }, [roleAccessMap]);
}
